module.exports = __webpack_public_path__ + "images/emoji/part_alternation_mark.0d16f62fd846899335f6.png";